<input [formControl]="formControl" />
<span class="button material-icons">more_horiz</span>
<span class="button material-icons" (click)="resetValue()">close</span>
